import areas from '../../static/js/area';

export default {
    name: 'AreaSelector',
    props: {
        confirmHandler: {
            type: Function
        },
        cancelHandler: {
            type: Function,
            default() {
                return function() {};
            }
        }
    },
    data() {
        let provinceList = [], cityList = [], countyList = [];

        provinceList = areas.map(item => item.name);
        cityList = areas[0]['city'].map(item => item.name);
        countyList = areas[0]['city'][0]['area'];

        return {
            provinceList, // 省份列表
            cityList, // 城市列表
            countyList, // 区县列表
            selectedProvince: areas[0], // 选中的省份
            selectedCity: areas[0]['city'][0], // 选中的城市
            selectedCounty: areas[0]['city'][0]['area'][0], // 选中的区
        };
    },
    methods: {
        selectProvinceHandler(item) {
            const province = areas.filter(n => n.name === item)[0];
            if(province) {
                this.selectedProvince = province;
                this.cityList = province['city'].map(item => item.name);
                this.selectCityHandler(province['city'][0].name);
            }
        },
        selectCityHandler(item) {
            const city = this.selectedProvince['city'].filter(n => n.name === item)[0];
            if(city) {
                this.selectedCity = city;
                this.countyList = [ ...city['area'] ];
                this.selectCountyHandler(city['area'][0]);
            }
        },
        selectCountyHandler(item) {
            this.selectedCounty = item;
        }
    },
    render() {
        const { confirmHandler, cancelHandler,
			provinceList, selectedProvince, cityList, selectedCity, countyList, selectedCounty,
			selectProvinceHandler, selectCityHandler, selectCountyHandler } = this;

        const selectedRegion = `${selectedProvince.name === selectedCity.name ? '' : selectedProvince.name + '省 '}${selectedCity.name}市 ${selectedCounty}`; // 选中的省市区信息
        const selectedjson = {
            'province':selectedProvince.name,
            'city':selectedCity.name,
            'district':selectedCounty
        };
        return (
			<section class="area_selector">
				<div class="area_buttons">
					<div class="area_cancel" onClick={ cancelHandler }>取消</div>
					<div class="area_confirm" onClick={ () => confirmHandler(selectedRegion,selectedjson) }>确认</div>
				</div>
				<div class="area_container">
					<div class="area_list">
						{
							provinceList.map(item => {
    return (
									<div
										class={ { 'selected': selectedProvince.name === item } }
										onClick={ () => selectProvinceHandler(item) }>{ item }</div>
    );
})
						}
					</div>
					<div class="area_list">
						{
							cityList.map(item => {
    return (
									<div
										class={ { 'selected': selectedCity.name === item } }
										onClick={ () => selectCityHandler(item) }>{ item }</div>
    );
})
						}
					</div>
					<div class="area_list">
						{
							countyList.map(item => {
    return (
									<div
										class={ { 'selected': selectedCounty === item } }
										onClick={ () => selectCountyHandler(item) }>{ item }</div>
    );
})
						}
					</div>
				</div>
			</section>
        );
    }
};
